import React from "react";

export default function ProgressDots({ total, current }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "0.375rem",
        marginTop: "0.875rem",
      }}
    >
      {Array.from({ length: total }).map((_, index) => {
        const isActive = index === current;

        return (
          <div
            key={index}
            style={{
              width: isActive ? "1.125rem" : "0.5rem",
              height: "0.5rem",
              borderRadius: "999px",
              backgroundColor: isActive ? "#4CAF50" : "#B8B8B8",
              transition: "all 0.25s ease",
            }}
          />
        );
      })}
    </div>
  );
}